// 数结构递归的一个方法
export function getMock(treeData, opts = {}) {
  // special这个参数是针对201这个模块的部门树特殊处理 ,默认值是根据levelid来分层
  const { parentId = "parentid", keyId = "keyid", special = "levelid" } = opts;
  let groupsIndex = [],
    groups = [],
    res = {},
    arrayTree = [];

  // 判断把整个树的数据的层级分离出来
  if (treeData !== undefined) {
    treeData.forEach(item => {
      if (!groupsIndex.includes(item[special])) {
        groupsIndex.push(item[special]);
      }
    });
  }
  // 把上步分离的层级排序，从大到小
  let arr = groupsIndex.sort((a, b) => a > b);
  // 把树的数据和分离好的层级匹配，层级一样的丢进一个数组按层级排了序
  arr.forEach(it => {
    groups.push(treeData.filter(o => o[special] == it));
  });
  // 层级图标对应关系表
  // const rs = {
  //   0: "firstLevelIcon",
  //   //打开的
  //   1: "secondaryIcon",
  //   //没打开的
  //   2: "threeLevelIcon",
  //   3: "fourLevelIcon",
  //   4: "fiveLevelIcon",
  //   5: "sixLevelIcon"
  // };
  // //判断树层级把图标给相应图层加上去
  // groups.forEach((item, idx) => {
  //   item.forEach(el => {
  //     el.icons = rs[idx];
  //     if (idx > 5)
  //     {
  //       el.icons = rs[5];
  //     }
  //   });
  // });
  // 判断树层级然后把第二层的keyid加进一个数组
  groups.forEach((item, idex) => {
    if (idex === 1) {
      item.forEach((el, index) => {
        arrayTree[index] = el.keyid;
      });
    }
  });

  function bb(arr) {
    // 把层级数组丢进一个空数组ffff中
    let ffff = [].concat(arr);
    // len表示有多少个层级或者是获得最后一级
    var len = arr.length;
    // 判断条件至少有俩个层级
    if (len - 1 > 0) {
      // 倒数第二级
      ffff[len - 2].forEach((item, index) => {
        // 倒数第二级 autoid ==> 最后一级 的parentid
        item.children = ffff[len - 1].filter(it => {
          if (it[parentId] == item[keyId]) {
            it.parentName = item.keyname;
          }
          return it[parentId] == item[keyId];
        });
      });

      return bb(ffff.slice(0, -1));
    } else {
      const res = ffff;
      return res;
    }
  }

  res = bb(groups);
  return {
    trData: res[0],
    trNode: arrayTree,
    groupsIndex,
    groups,
    res,
    arrayTree
  };
}

// 根据parentid来创造数组
export function fatherMock(originData) {
  const rootNode = originData.filter((n) => n.levelid === 0);
  // console.log(rootNode,'rootNoderootNode')
  const genChildren = (parents) => {
    const tempParents = parents.map((parent) => {
      const children = originData.filter((m) => (m.parentid == parent.keyid));
      // console.log(parent,'parentparent')
      const tempParent = {
        ...parent,
        parentname: parent.keyname,
      };
      if (children.length > 0) {
        tempParent.children = genChildren(children);
      }
      return tempParent;
    });
    return tempParents;
  };
  const tempTreeData = genChildren(rootNode);
  return tempTreeData;
}

// 点击左边树节点，转换获取右边表格的sql语句
export function translateQuerySql(moduleConfig, node) {
  const username = JSON.parse(sessionStorage.userInfo).username;
  let sql = moduleConfig[`t${node.levelid}_clisql`];
  sql = sql.replace(/@autoid/g, node.autoid);
  sql = sql.replace(/@keyid/g, node.keyid);
  sql = sql.replace(/@keyname/g, node.keyname);
  sql = sql.replace(/@treevalue/g, `'${node.keyname}'`);
  sql = sql.replace(/@levelid/g, node.levelid);
  sql = sql.replace(/@treelevel/g, node.levelid);
  sql = sql.replace(/@crman/g, `'${username}'`);
  sql = sql.replace(/@username/g, `'${username}'`);
  return sql;
}

// 点击左边树节点，转换获取右边表格的sql语句
export function translateCustomQuerySql(moduleConfig, node) {
  const username = JSON.parse(sessionStorage.userInfo).username;
  let sql = moduleConfig["treesql" + node.levelid];
  sql = sql.replace(/@autoid/g, node.autoid);
  sql = sql.replace(/@keyid/g, node.keyid);
  sql = sql.replace(/@keyname/g, node.keyname);
  sql = sql.replace(/@treevalue/g, `'${node.keyname}'`);
  sql = sql.replace(/@levelid/g, node.levelid);
  sql = sql.replace(/@treelevel/g, node.levelid);
  sql = sql.replace(/@crman/g, `'${username}'`);
  sql = sql.replace(/@username/g, `'${username}'`);
  return sql;
}

// 生成全球唯一标识GUID （参考：https://blog.csdn.net/Alive_tree/article/details/87942348）
export function createGguid() {
  return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// 导出excel
// header: [key,key,...] tableData: [{key: value, key: v...}, ...]
// 即：header: [工号, 姓名, ...] tableData: [{工号:031354, 姓名：xxx，...},....]
export function exportExcel(filename, params) {
  const suffix = ".xls"; // 后缀
  const { header, tableData, failTitle = [] } = params;
  let hHtml = "",
    cHtml = "";
  console.log(failTitle, "failtitle");
  header.forEach(item => {
    // 循环头
    if (failTitle.includes(item)) {
      hHtml += `<th class="error">${item}</th>`;
    } else {
      hHtml += `<th>${item}</th>`;
    }
  });
  tableData.forEach(item => {
    // 循环体
    let tds = "";
    header.forEach(k => {
      let val = "";
      if (/^true$/.test(item[k]) || /^false$/.test(item[k])) {
        val = item[k];
      } else {
        val = item[k];
      }
      if (failTitle.includes(k)) {
        tds += `<td class="error">${val}</td>`;
      } else {
        tds += `<td>${val}</td>`;
      }
    });
    cHtml += `<tr>${tds}</tr>`;
  });
  const excelHtml = `
    <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta http-equiv="X-UA-Compatible" content="ie=edge">
        <title>Document</title>
        <style media="screen">
          .tableA {
            border-collapse: collapse;
          }
          .tableA .title th {
            height: 24px;
            border: 0.5px #ccc solid;
            background: #efefef;
          }
          .tableA tr td {
            border: 0.5px #ccc solid;
            height: 48px;
            mso-number-format:'\@';
            width:fit-content;
          }
          .error {
            background: red;
          }
        </style>
      </head>
      <body>
        <table bordercolor="black" class="tableA">
          <tr class="title">
            ${hHtml}
          </tr>
          ${cHtml}
        </table>
      </body>
    </html>
  `;
  // document.body.innerHTML = excelHtml
  const excelBlob = new Blob([excelHtml], { type: "application/vnd.ms-excel" });
  // 创建一个a标签
  const oA = document.createElement("a");
  // 利用URL.createObjectURL()方法为a元素生成blob URL
  oA.href = URL.createObjectURL(excelBlob);
  // 给文件命名
  oA.download = filename + suffix;
  // 模拟点击
  oA.click();
}

// 记录报表详情列表（利用sessionStorage，做缓存）
export function setReportList({ moduleno, rpurl, rpname } = params) {
  const list = JSON.parse(sessionStorage.getItem("reportList")) || [];
  const rp = list.some(item => {
    return Number(item.module) === Number(moduleno) && item.rpname === rpname;
  });
  if (rp) {
    // 更新
    list.forEach(item => {
      if (Number(item.module) === Number(moduleno) && item.rpname === rpname) {
        item.rpurl = rpurl;
      }
    });
  } else {
    // 添加
    list.push({
      module: String(moduleno), // 模块号
      rpurl: rpurl, // 报表地址
      rpname: rpname // 报表名称
    });
  }
  sessionStorage.setItem("reportList", JSON.stringify(list));
}

// 计算表格列头宽度（不换行） 参考自：labelHead 可全局搜索一下，在其他模块有引用的
export function calculateWidth(h, { column, $index }) {
  const len = column.label.length;
  const fontSize = 16;
  column.minWidth = fontSize * (len + 1.5); // 加上一个文字长度
  return h("div", { class: "table-head", style: { width: "100%" } }, [
    column.label
  ]);
}

// 获取table选中项：用于判断当前模块的table组件是否有勾选项（只选一条）
export function getTableRow(table) {
  return new Promise((resolve, reject) => {
    const selectData = table.selectData;
    if (selectData.length) {
      // 如果用户多选table数据的，取最后一条
      const len = selectData.length;
      resolve(selectData[len - 1]);
    } else if (table.tableData.length) {
      // 如果用户没有选table数据的情况下，取第一条
      resolve(table.tableData[0]);
    } else {
      // 如果table数据都没有，点击不处理
      reject("表格暂无数据，禁止操作！");
    }
  });
}

/*
 * 设置输入域(input/textarea)光标的位置
 * @param {HTMLInputElement/HTMLTextAreaElement} elem
 * @param {Number} index
 */
export function setCursorPosition(elem, index) {
  var val = elem.value;
  var len = val.length;
  elem.focus();
  // 超过文本长度直接返回
  if (len < index) return;
  setTimeout(function() {
    if (elem.setSelectionRange) {
      // 标准浏览器
      elem.setSelectionRange(index, index);
    } else {
      // IE9-
      var range = elem.createTextRange();
      range.moveStart("character", -len);
      range.moveEnd("character", -len);
      range.moveStart("character", index);
      range.moveEnd("character", 0);
      range.select();
    }
  }, 10);
}

// 获取光标位置  参考链接：https://www.cnblogs.com/rubylouvre/articles/1885845.html
export function getCursorPosition(textarea) {
  let idx = 0;
  textarea.focus();
  if (textarea.setSelectionRange) {
    // W3C
    idx = textarea.selectionStart;
  } else if (document.selection) {
    // IE
    let i,
      oR = document.body.createTextRange();
    for (
      i = 0;
      oR.compareEndPoints("StartToStart", oS) < 0 &&
      oS.moveStart("character", -1) !== 0;
      i++
    ) {
      if (textarea.value.charAt(i) == "\n") {
        i++;
      }
    }
    idx = i;
  }
  return idx;
}

// 数组扁平化处理
export function flatten(arr) {
  return arr.reduce((pre, cur) => {
    return pre.concat(cur.children.length === 0 ? cur : flatten(cur));
  });
}

/**
 * 描述：实现 element-ui 的 dialog 弹窗拖拽功能
 * 使用：1.<el-dialog v-dialogDrag ...
        2.<script>
          import { drag } from '@/utils/pubMethods'
          export default {
            directives: {
              dialogDrag: {
                bind: drag
              }
            },
            ...
 */
// -------------------- @toWatch 待参考 2020-09-18 ----------------------
export function drag(el, binding, vnode, oldVnode) {
  const dialogHeaderEl = el.querySelector(".el-dialog__header");
  const dragDom = el.querySelector(".el-dialog");
  dialogHeaderEl.style.cursor = "move";
  // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
  const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
  dialogHeaderEl.onmousedown = e => {
    // 判断当前是否为全屏状态
    const path = event.path || (event.composedPath && event.composedPath());
    const isFull = path.find(s => {
      if (s.className === undefined) {
        return false;
      } else {
        return s.className.indexOf("is-fullscreen") > -1;
      }
    });
    if (isFull !== undefined) {
      return;
    }
    const isMinix = path.find(s => {
      if (s.className === undefined) {
        return false;
      } else {
        return s.className.indexOf("isminimize") > -1;
      }
    });
    if (isMinix !== undefined) {
      return;
    }
    // 鼠标按下，计算当前元素距离可视区的距离
    const disX = e.clientX - dialogHeaderEl.offsetLeft;
    const disY = e.clientY - dialogHeaderEl.offsetTop;

    // 获取到的值带px 正则匹配替换
    let styL, styT;

    // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
    if (sty.left.includes("%")) {
      styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, "") / 100);
      styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, "") / 100);
    } else {
      styL = +sty.left.replace("px", "");
      styT = +sty.top.replace("px", "");
    }

    document.onmousemove = function(e) {
      // 通过事件委托，计算移动的距离
      const l = e.clientX - disX;
      const t = e.clientY - disY;
      // 移动当前元素
      dragDom.style.left = `${l + styL}px`;
      dragDom.style.top = `${t + styT}px`;
    };

    document.onmouseup = function(e) {
      const dragDom = el.querySelector(".el-dialog");
      const offsetLeft = dragDom.offsetLeft - dragDom.offsetWidth / 2;
      const offsetTop = dragDom.offsetTop - dragDom.offsetHeight / 2;
      const left = Number(dragDom.style.left.replace("px", ""));
      const top = Number(dragDom.style.top.replace("px", ""));
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const offsetRight = offsetLeft + dragDom.offsetWidth - windowWidth;
      const offsetBottom =
        offsetTop + dialogHeaderEl.offsetHeight - windowHeight;
      if (offsetLeft < 0) {
        dragDom.style.left = left - offsetLeft + "px";
      }
      if (offsetTop < 0) {
        dragDom.style.top = top - offsetTop + "px";
      }
      if (offsetRight > 0) {
        dragDom.style.left = left - offsetRight + "px";
      }
      if (offsetBottom > 0) {
        dragDom.style.top = top - offsetBottom + "px";

        // dragDom.style.top = dragDom.offsetHeight-windowHeight + 'px'
      }
      document.onmousemove = null;
      document.onmouseup = null;
    };
  };
}

export function rdrag(el, binding, vnode, oldVnode) {
  const dialogHeaderEl = el.querySelector(".routerDialogHeader");
  const dragDom = el.querySelector(".routerDialogContent");
  dialogHeaderEl.style.cursor = "move";
  const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);
  let firstAction = true;
  if(firstAction && !window.pclick){
    firstAction = false;
    dialogHeaderEl.onmouseover = e => {
      const dragDom = el.querySelector(".routerDialogContent");
      dragDom.style.position = "absolute";
      const left = Number(dragDom.offsetLeft);
      const top = Number(dragDom.offsetTop);
      dragDom.style.left = left + "px";
      dragDom.style.top = top + "px";
    }
  }
  dialogHeaderEl.onmousedown = e => {
    const dragDom = el.querySelector(".routerDialogContent");
    dragDom.style.position = "absolute";
    let crect = dragDom.getBoundingClientRect();
    // 关闭的时候 如果能给一个参数 就可以加入这个
    if (window.pclick) {
      dragDom.style.left = "50%";
      dragDom.style.top = "50%";
      dragDom.style.marginLeft = -(crect.width / 2) + "px";
      dragDom.style.marginTop = -(crect.height / 2) + "px";
    }
    // 判断当前是否为全屏状态
    const path = event.path || (event.composedPath && event.composedPath());
    const isFull = path.find(s => {
      if (s.className === undefined) {
        return false;
      } else {
        return s.className.indexOf("is-fullscreen") > -1;
      }
    });
    if (isFull !== undefined) {
      return;
    }
    const isMinix = path.find(s => {
      if (s.className === undefined) {
        return false;
      } else {
        return s.className.indexOf("isminimize") > -1;
      }
    });
    if (isMinix !== undefined) {
      return;
    }
    // 鼠标按下，计算当前元素距离可视区的距离
    const disX = e.clientX - dialogHeaderEl.offsetLeft;
    const disY = e.clientY - dialogHeaderEl.offsetTop;

    // 获取到的值带px 正则匹配替换
    let styL, styT;

    // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
    if (sty.left.includes("%")) {
      styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, "") / 100);
      styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, "") / 100);
    } else {
      styL = +sty.left.replace("px", "");
      styT = +sty.top.replace("px", "");
    }

    document.onmousemove = function(e) {
      // 通过事件委托，计算移动的距离
      const l = e.clientX - disX;
      const t = e.clientY - disY;
      // 移动当前元素
      dragDom.style.left = `${l + styL}px`;
      dragDom.style.top = `${t + styT}px`;
    };

    document.onmouseup = function(e) {
      window.pclick = false;
      firstAction = true;
      const dragDom = el.querySelector(".routerDialogContent");
      const left = Number(dragDom.style.left.replace("px", ""));
      const top = Number(dragDom.style.top.replace("px", ""));
      dragDom.style.left = left + "px";
      dragDom.style.top = top + "px";
      document.onmousemove = null;
      document.onmouseup = null;
    };
  };
}

/**
 * 根据页数切割table数据，得到各分页数据
 * params     pageSize-页数 list-table数据
 * return     [[...], [...]]
 */
export function paging(size = 1, list = []) {
  const total = Math.ceil(list.length / size); // 页数
  let res = [];
  for (let i = 1; i <= total; i++) {
    const arr = list.slice((i - 1) * size, i * size); // 切割
    res.push(arr); // 从1开始  [(页码-1)*每页数，页码*每页数 - 1]
  }
  return res;
}

// 16进制 转 10进制
export function hex2int(hex) {
  console.log(hex,'hex2inthex2int')
  if (hex) {
    let size = "";
    if(typeof hex == 'number'){
      return hex; 
    }else{
      size = hex.slice(1);
      var len = size.length;
      var a = new Array(len);
      var code;
      for (var i = 0; i < len; i++) {
        code = size.charCodeAt(i);
        if (code >= 48 && code < 58) {
          code -= 48;
        } else {
          code = (code & 0xdf) - 65 + 10;
        }
        a[i] = code;
      }
      return a.reduce(function(acc, c) {
        acc = 16 * acc + c;
        return acc;
      }, 0);
    }
  }
}

// 10进制 转 16进制
// 这个函数有严重的问题 不要再使用
export function int2hex(num, width) {
  var hex = "0123456789abcdef";
  var s = "";
  while (num) {
    s = hex.charAt(num % 16) + s;
    num = Math.floor(num / 16);
  }
  if (typeof width === "undefined" || width <= s.length) {
    return s;
  }
  var delta = width - s.length;
  var padding = "";
  while (delta-- > 0) {
    padding += "0";
  }
  return padding + s;
}

// 颜色值转数字
export function colorToNumber(color) {
  if(color){
    if(typeof color == 'string' && color.indexOf("#") == 0){
      color = parseInt(color.slice(1),16);
    }
  }else{
    color = null;
  }
  return color;
}

// 十进制数字转HEX
export function colorToHex(color) {
  if(color){
    if(typeof color != 'string'){
      color = '#'+Math.abs(color).toString(16).padStart(6,0);
    }
  }else{
    color = '';
  }
  return color;
}

/**
 * 十六进制颜色值转为带透明度的颜色
 * @param _color 十六进制颜色
 * @param _opacity 透明度
 * @returns {string} rgba
 */
export function hexToRGBA(_color, _opacity) {
  var sColor = _color.toLowerCase();
  //十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 如果是16进制颜色
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    //处理六位的颜色值
    var sColorChange = [];
    for (var i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
    }
    return "rgba(" + sColorChange.join(",") + "," + _opacity + ")";
  }
  return sColor;
}

/**
 * 将base64转换为文件
 *
 * @export
 * @param {string} base64 带前缀的base64
 * @param {string} filename 最终保存的文件名
 * @return {blob}  文件流
 */
export function dataURLtoFile(base64, filename) {
  var arr = base64.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

/**
 * 日期格式验证
 *
 * @export
 * @param {String} date   要判断的字符串
 * @param {String} format 格式：yyyy-MM-dd、yyyyMMdd、yyyyMM（目前只支持3种）
 * @return {Boolean}      date是否符合format格式
 */
export function checkDate(date, format) {
  let reg = null;
  switch (format) {
    case "yyyy-MM-dd":
      reg = /^(\d{1,4})(-)(\d{1,2})\2(\d{1,2})$/;
      break;
    case "yyyyMMdd":
      reg = /^(\d{1,4})(\d{1,2})(\d{1,2})$/;
      break;
    case "yyyyMM":
      reg = /^(\d{1,4})(\d{1,2})$/;
      break;
  }
  if (date.length === format.length) {
    const r = date.match(reg);
    if (r === null) {
      //不符合格式
      return false;
    } else {
      //除去不正确时间:如1234-45-56
      let d = null;
      switch (format) {
        case "yyyy-MM-dd":
          d = new Date(r[1], r[3] - 1, r[4]);
          return (
            d.getFullYear() == r[1] &&
            d.getMonth() + 1 == r[3] &&
            d.getDate() == r[4]
          );
        case "yyyyMMdd":
          d = new Date(r[1], r[2] - 1, r[3]);
          return (
            d.getFullYear() == r[1] &&
            d.getMonth() + 1 == r[2] &&
            d.getDate() == r[3]
          );
        case "yyyyMM":
          d = new Date(r[1], parseInt(r[2]) - 1, "01");
          return (
            d.getFullYear() == parseInt(r[1]) &&
            d.getMonth() + 1 == parseInt(r[2])
          );
      }
      return new Error("没有找到能匹配的时间格式");
    }
  }
}

/**
 * 判断：华跃简历助手 是否安装成功
 *
 * @param {String} id   chrome extension id
 * @export
 * @return {Promise}
 */
export function helperExist(id) {
  var extensionid = id || "ijhhceomkgmjdgdmgflbcclkkccgcagb";
  return new Promise((resolve, reject) => {
    var image = document.createElement("img");
    image.src = "chrome-extension://" + extensionid + "/img/logo.png";
    image.onload = function() {
      resolve(true);
    };
    image.onerror = function() {
      resolve(false);
    };
  });
}

/**
 * 出入身份证，返回籍贯信息
 *
 * @param {String} idcardnum   chrome extension id
 * @export
 * @return {Json}
 *
 */
export function GetNativePlace(idcardnum) {
  const str = idcardnum.substring(0, 2);
  let nativeplace = "";
  switch (str) {
    case "11":
      nativeplace = "北京";
      break;
    case "12":
      nativeplace = "天津";
      break;
    case "13":
      nativeplace = "河北";
      break;
    case "14":
      nativeplace = "山西";
      break;
    case "15":
      nativeplace = "内蒙";
      break;
    case "21":
      nativeplace = "辽宁";
      break;
    case "22":
      nativeplace = "吉林";
      break;
    case "23":
      nativeplace = "黑龙";
      break;
    case "31":
      nativeplace = "上海";
      break;
    case "32":
      nativeplace = "江苏";
      break;
    case "33":
      nativeplace = "浙江";
      break;
    case "34":
      nativeplace = "安徽";
      break;
    case "35":
      nativeplace = "福建";
      break;
    case "36":
      nativeplace = "江西";
      break;
    case "37":
      nativeplace = "山东";
      break;
    case "41":
      nativeplace = "河南";
      break;
    case "42":
      nativeplace = "湖北";
      break;
    case "43":
      nativeplace = "湖南";
      break;
    case "44":
      nativeplace = "广东";
      break;
    case "45":
      nativeplace = "广西";
      break;
    case "46":
      nativeplace = "海南";
      break;
    case "50":
      nativeplace = "重庆";
      break;
    case "51":
      nativeplace = "四川";
      break;
    case "52":
      nativeplace = "贵州";
      break;
    case "53":
      nativeplace = "云南";
      break;
    case "54":
      nativeplace = "西藏";
      break;
    case "61":
      nativeplace = "陕西";
      break;
    case "62":
      nativeplace = "甘肃";
      break;
    case "63":
      nativeplace = "青海";
      break;
    case "64":
      nativeplace = "宁夏";
      break;
    case "65":
      nativeplace = "新疆";
      break;

    default:
      break;
  }
  return { nativeplace };
}
// 图片验证，如果图片加载失败则替换会默认图片
export function checkPic(
  item,
  picKey,
  setPic,
  defaultPic = require("@/assets/img/user.png")
) {
  let url = setPic ? setPic : item[picKey];
  url += "?v=" + Date.parse(new Date()); // 增加时间戳防止加载了图片缓存
  let img = new Image();
  img.src = url;
  return new Promise((resolve, reject) => {
    img.onload = () => {
      resolve(url);
    };
    img.onerror = function() {
      url = defaultPic;
      if (item) item[picKey] = defaultPic;
      reject(url);
    };
  });
}
